module.exports = __webpack_public_path__ + "static/media/shipped.f8a162a8.png";